// extracted by mini-css-extract-plugin
export default {"linkBlock":"help_linkBlock__ry1If","linkBlockTelegram":"help_linkBlockTelegram__gjpgr","linkBlockWhatsapp":"help_linkBlockWhatsapp__+M40r"};